import React from 'react'
import {NavLink} from "react-router-dom"
import pic from "../PicsAsset/logo.jpg"
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import DehazeOutlinedIcon from '@mui/icons-material/DehazeOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useState } from 'react';
import "../css/Navbar.css"


const NavBar = () => {

  const [menu, setMenu] = useState(false)
   

  const toggleMenu =()=>{
    setMenu(!menu)
  };

  // const handleemail=()=>{
  //   window.location = "mailto:missionaryabra@gmail.com";
  // }

  return (
    <div className='wrapper'>
    <div className='main  w-[100vw] flex justify-around  ' >
      
      <div className='img '>
     <div className='imgdiv flex items-center h-[12vh] '>
            <img src={pic} alt='Logo pic' className=' h-[100px] rounded-full'></img>
            <p className='imgp text-[30px] font-[Marhey] uppercase'>olowu</p>
        </div> 

      </div>

         
         <div className='content flex items-center'>
        <div className='LargeNav flex   h-[12vh] items-center w-[100%] uppercase  text-[white]'>
          <div className='adjustnav'>
          <NavLink className=' cursor-pointer' to={'/'}><HomeOutlinedIcon sx={{ color: 'white', fontSize: 35}}/> Home</NavLink>
          <NavLink className=' cursor-pointer' to={'/about'}><CodeOutlinedIcon sx={{ color: 'white', fontSize: 35}}/> About</NavLink>
          <NavLink className=' cursor-pointer'  to={'/sayhi'}><SentimentSatisfiedOutlinedIcon sx={{ color: 'white', fontSize: 35}}/> Say Hi</NavLink>

          </div>
         </div>
          <div className='iconbar ' >
           
          {menu ? (
        <div onClick={toggleMenu} className=' cursor-pointer'>
           <CloseOutlinedIcon sx={{ color: 'white', fontSize: 40}} ></CloseOutlinedIcon>
        </div>
      ) : (
        <div onClick={toggleMenu} className=' cursor-pointer'>
          <DehazeOutlinedIcon sx={{ color: 'white', fontSize: 40}}></DehazeOutlinedIcon>
        </div>
      )}

             



          </div>
         </div>

    </div>
  {/* division */}



    <div className='mobienav w-full '>

      {
        menu ?(
          
          <div className='Mnav flex justify-around    uppercase  text-[white]'>
          <div className='Mobilediv'>
          <NavLink className=' cursor-pointer' onClick={toggleMenu} to={'/'}><HomeOutlinedIcon className='icon' sx={{ color: 'white', fontSize: 30}}/> Home</NavLink>
          <NavLink className=' cursor-pointer' onClick={toggleMenu} to={'/about'}><CodeOutlinedIcon sx={{ color: 'white', fontSize: 30, marginRight:0.5}}/>About</NavLink>
          <NavLink className=' cursor-pointer' onClick={toggleMenu} to={'/sayhi'}><SentimentSatisfiedOutlinedIcon sx={{ color: 'white', fontSize:30}}/> Say Hi</NavLink>
         </div>

            </div>
          
        ): (
          <div >
            
          </div>
        )
      }
           
           </div>
    </div>
  )
}

export default NavBar

















// import DehazeOutlinedIcon from '@mui/icons-material/DehazeOutlined';
// import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';